<mat-card appearance="outlined" class="mb-3">
  <mat-card-header>
    <div class="folder-header">
      <mat-icon class="avatar">{{ folder().icon }}</mat-icon>
      <mat-card-title class="folder-title" [class.long-title]="isLongTitle()">{{ displayName() }}</mat-card-title>
      @if (hasPatientDetails() && patientId()) {
        <xmed-file-upload-button
          [iconButton]="true"
          [patientId]="patientId()"
          [tags]="tags()"
          uploadType="patient">
          Upload
        </xmed-file-upload-button>
      }
    </div>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      @for (upload of filteredUploads(); track upload.id) {
        <mat-list-item lines="3">
          <xui-file-icon
            class="mt-3 me-3"
            matListItemAvatar
            [extension]="upload.extension"
            [grayscale]="upload.processing"
            (click)="fileDownloader.openUpload()">
          </xui-file-icon>
          <div matListItemTitle (click)="fileDownloader.openUpload()">{{ upload.fileName }}</div>
          <div matListItemLine (click)="fileDownloader.openUpload()">{{ upload.size | fileSize }}</div>
          <div matListItemLine (click)="fileDownloader.openUpload()">{{ upload.documentDate | date:'yyyy-MM-dd':'+0200' }}</div>
          <div matListItemMeta>
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.preventDefault()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              @if (!upload.processing) {
                <button mat-menu-item (click)="fileEditor.editAttachment()">
                  <mat-icon>edit</mat-icon>Edit
                </button>
                <button mat-menu-item (click)="fileEditor.deleteAttachment()">
                  <mat-icon>delete</mat-icon>Delete
                </button>
              }
              <xmed-file-downloader #fileDownloader [upload]="upload"></xmed-file-downloader>
              <xmed-file-editor #fileEditor [upload]="upload"></xmed-file-editor>
            </mat-menu>
          </div>
        </mat-list-item>
      }
      @if (filteredUploads().length === 0) {
        <mat-list-item>
          <span matListItemTitle>No files have been uploaded in this folder.</span>
        </mat-list-item>
      }
    </mat-list>
  </mat-card-content>
</mat-card>
